<template>
    <div class="tile-content tile-content-secondary">
        <div class="grid-content position-relative">
            <div class="grid-item grid-item-full">
                <p>Entering a number here will affect the transaction's risk score. Entering a negative number will
                    decrease the risk while entering a positive number will increase the risk.</p>
            </div>
            <div class="grid-item grid-item-half">
                <div class="grid-content">
                    <div class="grid-item grid-item-third">
                        <r-input
                            label="Amount"
                            :value="action.score"
                            @input="updateScore"
                            :validate="$v.action.score"
                            help-text="e.g. 20, -100, 55"/>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import BaseAction from '../base-action';

    export default {
        name: 'add-risk-score',
        extends: BaseAction,
        data() {
            return {};
        },
        validations: {
            action: {
                score: {
                    required,
                    riskScore(value) {
                        return !isNaN(value);
                    },
                },
            },
        },
        methods: {
            updateScore(score) {
                this.$emit('input', this.action.cloneSelf({score}));
            },
            getValidationAggregate() {
                return {
                    name: 'add-risk-score',
                    rules: [
                        {
                            name: 'The risk score value is required.',
                            delegate: () => {
                                this.$v.$touch();
                                return !this.$v.action.score.required;
                            },
                        },
                        {
                            name: 'The risk score value must be a valid number.',
                            delegate: () => {
                                this.$v.$touch();
                                return !this.$v.action.score.riskScore;
                            },
                        },
                    ],
                };
            },
        },
    };
</script>
